<template>
    <div class="knob__holder">
        <div class="knob__item knob__item--knob" v-if="knobDetail.type === 'knob'">
            <div class="knob--knob" :style="{ 'transform': 'rotate('+knobValue+'deg)' }"></div>
            <input type="range" v-model="knobValue" v-on:change="updateValue()" min="0" max="320" v-if="edit" />
        </div>

        <div class="knob__item knob__item--slider" v-if="knobDetail.type === 'slider'">
            <div class="knob--slider">
                <div class="knob--slider__bar" :style="{ 'height': knobValue+'%' }"></div>
            </div>
            <input type="range" v-model="knobValue" v-on:change="updateValue()" min="0" max="100" v-if="edit" />
        </div>

        <div v-if="knobDetail.type === 'switch'" class="knob__item knob__item--switch">
            <input type="checkbox" v-on:change="updateValue()" v-model="knobValue" v-if="edit">
            <span class="knob--switch knob--switch--on" v-if="knobValue">ON</span>
            <span class="knob--switch knob--switch--off" v-else>OFF</span>
        </div>

        <div v-if="knobDetail.type === 'options'" class="knob__item knob__item--options">

            <span class="knob--options">
                <span v-if="edit">{{ knobValue }}</span>
                <span v-if="!edit">{{ knobDetail.title }}</span>
                <span v-if="!edit && knobPreview">Options</span>
            </span>
            <select v-model="knobValue" v-on:change="updateValue()" v-if="edit">
                <option v-for="item in knobDetail.options" :key="item" :value="item">{{ item }}</option>
            </select>
            <select v-if="!edit">
                <option v-for="item in knobDetail.options" :key="item" :value="item">{{ item }}</option>
            </select>
        </div>

        <strong>
            <span v-if="knobDetail.title">{{ knobDetail.title }}</span>
            <span v-else>{{ knobPreview }}</span>
        </strong>
        <small v-if="value && !knobValue">No value set</small>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
    name: "Knob",
    data() {
        return {
            knobValue: this.value
        }
    },
    props: {
        edit: {
            type: Boolean,
            required: false,
            default: false
        },
        knobId: {
            type: String,
            required: false
        },
        gearId: {
            type: String,
            required: false
        },
        value: {
            required: false,
            default: null
        },
        knobPreview: {
            required: false,
            type: String
        }
    },
    computed: {
        ...mapState(['gear']),
        knobDetail() {
            if(this.gearId && this.gear.length) {
                const gear = this.gear.find((g) => g.id === this.gearId)
                return gear.knobs.find((knob) => knob.id === this.knobId)
            } else {
                return {
                    type: this.knobPreview
                }
            }
        }
    },
    methods: {
        updateValue: function() {
            this.$emit('updateValue', { gearId: this.gearId, knobId: this.knobId, value: this.knobValue })
        }
    }
}
</script>